import { LRUCache } from 'src/common/utils/lru-cache';

export const newUserTaskStorage = new LRUCache<string, { step1?: boolean; step2?: boolean }>(
  localStorage,
  'newUserTaskStorage',
  50
);
